


















import { Component, Vue } from "vue-property-decorator";
import companyApi from "@/api/companyApi";
import Company from "@/model/company";
import click2Top from "@/common/directives/click2Top";
import CompanyInfoEdit from "@/components/company/companyInfoEdit.vue";
import CompanyInfoView from "@/components/company/companyInfoView.vue";
import CompanyCooperationList from "@/components/company/companyCooperationList.vue";
import {namespace} from "vuex-class";
import User from "@/model/user";
const authStore = namespace("Auth");
@Component({
  name: "CompanyInfo",
  directives: {
    click2Top,
  },
  components: {
    CompanyInfoEdit,
    CompanyInfoView,
    CompanyCooperationList,
  }
})
export default class PartnerList extends Vue {
  @authStore.Getter
  public affiliationCompanyId!: string;
  @authStore.Getter
  getUserLogging!: User
  public company: Company = new Company();

  @authStore.Getter
  public isManager;

  public isRepresentCompany = true;

  mounted() {
    this.setDataInfo();
  }

  public async setDataInfo() {
    await this.getCompany();
    this.setIsRepresentCompany();
  }

  public setIsRepresentCompany() {
    this.isRepresentCompany = this.company.representative_user_id == this.getUserLogging.id;
  }

  public async getCompany() {
    const result = await companyApi.show(this.affiliationCompanyId);
    this.company = new Company(result.data);
  }
}
